import { matchPath } from "react-router-dom";

import { ProviderSSO } from "services/firebase/auth/types";

import { pushLastActionPayloadToDataLayer } from "seneca-common/features/analytics/gtm";
import { isUserManaged } from "seneca-common/features/user/state";

import {
  linkToEndSessionModal,
  linkToSession
} from "features/classroom/routes/links";
import { linkToSignUpInvite } from "features/sign-up/links";
import { userAccountType } from "features/user/consts";

import { analyticsCategories } from "../consts";
import { logGTMTrackingEvent } from "../googleTagManager";

const findSignInLocation = (): string => {
  let location = "Dashboard";

  if (
    matchPath(window.location.pathname, {
      path: linkToEndSessionModal(),
      exact: false,
      strict: false
    })
  ) {
    location = "End session modal";
  } else if (
    matchPath(window.location.pathname, {
      path: linkToSession(),
      exact: false,
      strict: false
    })
  ) {
    location = "Mid session modal";
  }

  return location;
};

export const analyticsLogSignIn = (
  state: any,
  providerId: ProviderSSO = "password"
) => {
  logGTMTrackingEvent(
    {
      category: analyticsCategories.USER,
      event: "seneca/user/SIGN_IN",
      payload: {
        providerId,
        location: findSignInLocation(),
        isManaged: isUserManaged(state)
      }
    },
    state
  );
};

export const analyticsLogSignUp = (
  state: any,
  providerId: ProviderSSO = "password"
) => {
  logGTMTrackingEvent(
    {
      category: analyticsCategories.USER,
      event: "seneca/user/SIGN_UP",
      payload: {
        providerId,
        location: findSignInLocation()
      }
    },
    state
  );
};

export const analyticsLogSignOut = () => {
  logGTMTrackingEvent({
    category: analyticsCategories.USER,
    event: "seneca/user/SIGN_OUT"
  });
};

const analyticsLogCompletedStudentSecondStageSignUp = () => {
  logGTMTrackingEvent({
    category: analyticsCategories.NAVIGATION,
    event: "seneca/user/COMPLETED_STUDENT_SECOND_SIGN_UP_STAGE_SIGN_UP"
  });
};

const analyticsLogCompletedTeacherSecondStageSignUp = () => {
  logGTMTrackingEvent({
    category: analyticsCategories.NAVIGATION,
    event: "seneca/user/COMPLETED_TEACHER_SECOND_SIGN_UP_STAGE_SIGN_UP"
  });
};

const analyticsLogCompletedParentSecondStageSignUp = () => {
  logGTMTrackingEvent({
    category: analyticsCategories.NAVIGATION,
    event: "seneca/user/COMPLETED_PARENT_SECOND_SIGN_UP_STAGE_SIGN_UP"
  });
};

export const analyticsLogSkippedSecondStageSignUp = () => {
  logGTMTrackingEvent({
    category: analyticsCategories.NAVIGATION,
    event: "seneca/user/SKIPPED_SECOND_SIGN_UP_STAGE_SIGN_UP"
  });
};

export function logSignUpEventByAccountType(accountType: string) {
  switch (accountType) {
    case userAccountType.schoolteacher:
      if (
        matchPath(window.location.pathname, {
          path: linkToSignUpInvite()
        })
      ) {
        pushLastActionPayloadToDataLayer({
          "sign-up-invitee": true
        });
      }

      analyticsLogCompletedTeacherSecondStageSignUp();
      return;

    case userAccountType.schoolstudent:
      analyticsLogCompletedStudentSecondStageSignUp();
      return;

    case userAccountType.schoolparent:
      analyticsLogCompletedParentSecondStageSignUp();
      return;

    default:
      return;
  }
}
